import { render, staticRenderFns } from "./DynamicNumber.vue?vue&type=template&id=6ef8e785&"
import script from "./DynamicNumber.vue?vue&type=script&lang=js&"
export * from "./DynamicNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports